export const WAREHOUSE_STATUS = {
    ACTIVE: "ACTIVE",
    INACTIVE: "INACTIVE",
};

export const WAREHOUSE_STATUSES = [
    { id: WAREHOUSE_STATUS.ACTIVE, label: "active", color: "#33B950" },
    { id: WAREHOUSE_STATUS.INACTIVE, label: "inactive", color: "#C4C4C4" },
];
